import clsx from "clsx";

import { Button, ButtonProps } from "../button";

export type ModalFooterProps = {
  buttons?: (ButtonProps & { key?: string })[];
  loading?: boolean;
};

export const ModalFooter = ({ buttons, loading }: ModalFooterProps) => (
  <div
    className={clsx(
      "relative flex flex-col items-center justify-end gap-small px-[1.6rem] py-[0.8rem]",
      "mobile:px-[2.4rem] mobile:flex-row mobile:gap-medium mobile:h-[6.4rem] mobile:py-[1.2rem]",
      "[&>button]:w-full mobile:[&>button]:w-auto",
    )}
  >
    {buttons?.map((buttonProps) => (
      <Button key={buttonProps.key || buttonProps.text} {...buttonProps} />
    ))}
    {loading && <div className="absolute inset-0 cursor-wait" />}
  </div>
);
